// swiper
new Swiper('.swiper', {
  grabCursor: true,
  threshold: 5,
  centeredSlides: true,
  slidesPerView: 'auto',
  speed: 600,
  loop: true,
  autoplay: {
    delay: 3900,
    disableOnInteraction: false
  },
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})